//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class='content-wrapper'>
    <p style="font-size:16px;">Меню (внести сюда пункты меню)</p>
    <div v-if="(cmsMenus != null)">
      <entity-manager :data="cmsMenus" :options="cmsMenusEntityManagerOptions" style="padding-top: 20px;">
        <template slot="dataItemFieldTableView" scope="viewProps">
          <span v-if="viewProps.column.field == 'content'">
            <span v-if="(viewProps.dataRow.val[viewProps.column.field] != -1) && (viewProps.dataRow.val[viewProps.column.field] != '') && (viewProps.dataRow.val[viewProps.column.field] != null)">
              Есть
            </span>
            <span v-else>
              Нет
            </span>
          </span>
          <span v-else>
            {{viewProps.dataRow.val[viewProps.column.field]}}
          </span>
        </template>

        <template slot="dataItemFieldEditView" scope="viewProps">
          <span v-if="(viewProps.fieldKey == 'name') || (viewProps.fieldKey == 'url') || (viewProps.fieldKey == 'content')">
            <Input v-model="viewProps.editingDataRow.val[viewProps.fieldKey]" style="width:100%"></Input>
          </span>
          <div v-else style="width:100%; height: 26px">
            {{viewProps.editingDataRow.val[viewProps.fieldKey]}}
          </div>
        </template>
      </entity-manager>
    </div>
  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

import EntityManager from '@/technical/components/EntityManager'

export default {
  data () {
    return {
      cmsMenus: null,
      cmsMenusEntityManagerOptions: {
        tableColumns: [
          {title: 'id', width: '40px', field: 'id'},
          {title: 'Название', width: '', field: 'name'}
        ],
        editorFields: {name: 'Название', id: 'id'},
        newEmptyEntity: function (thisRef) {
          let result = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.cmsMenuResource)
          result.val = {}
          result.val.name = ''
          return result
        },
        commonDataReloadOptions: {},
        disableDelete: false
      }
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'commonData'
    ])
  },
  components: { EntityManager },
  created: function () {
    var thisRef = this

    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! это надо выносить в общий компонент читки статических данных с сервера и занесение их в store.CommonData
    var cmsMenus = []
    var cmsMenuResource = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.cmsMenuResource)
    cmsMenuResource.query()
    .then(function (response) {
      if (response.data == null) return serverErrorHandling('что-то не так', thisRef)
      // users[0] = {Name: '- Выберите автора -', id: 0}
      for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
        var oneCMSMenuResource = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.cmsMenuResource)
        oneCMSMenuResource.val = response.data[itemIndx]
        cmsMenus.push(oneCMSMenuResource)
      }
      thisRef.cmsMenus = cmsMenus
    })
    .catch((error) => serverErrorHandling(error, thisRef))
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px; /* margin: 25px 20px 50px 20px; */
  padding: 20px;
  background: #fff; height: 100%; /* если цвет отличный от стандартной серой подложики для content или убираем серые margins, то чтобы серый прикрыть надо height=100% */
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




// WEBPACK FOOTER //
// Menus.vue?38fbb86e